import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConnectService } from './api-connect.service';
import { ClothingDisposition, ClothingDispositionRequest, ClothingDispositionUnit,
  ClothingDispositionHistory, ClothingTypeReturnRequest } from '../models/clothing-disposition.model';
import { CLOTHING_DISPOSITION as C } from '../content-page/common/employee-assets/clothing-disposition.constants';
import { ASSET } from '../content-page/common/employee-assets/asset.constants';

@Injectable()
export class ClothingDispositionService {
  constructor(private http: HttpClient, private api: ApiConnectService) {}

  unit(id: string): Observable<ClothingDispositionUnit> {
    return this.http.get<ClothingDispositionUnit>(this.base() + C.units + encodeURIComponent(id));
  }

  returnType(employeeId: string, catalogItemId: string, request: ClothingTypeReturnRequest): Observable<Object> {
    return this.http.post(this.base() + EMPLOYEES + encodeURIComponent(employeeId)
      + ITEMS + encodeURIComponent(catalogItemId) + C.returnPath, request);
  }

  list(employeeId: string, page = ASSET.zero): Observable<ClothingDisposition[]> {
    const params = new HttpParams().set(ASSET.employeeId, employeeId).set(ASSET.page, String(page)).set(ASSET.size, String(ASSET.pageSize));
    return this.http.get<ClothingDisposition[]>(this.base(), {params: params});
  }


  detail(id: string): Observable<ClothingDisposition> {
    return this.http.get<ClothingDisposition>(this.base() + ASSET.slash + encodeURIComponent(id));
  }

  history(id: string): Observable<ClothingDispositionHistory[]> {
    return this.http.get<ClothingDispositionHistory[]>(this.base() + ASSET.slash + id + ASSET.history);
  }



  resume(id: string): Observable<ClothingDisposition> {
    return this.http.post<ClothingDisposition>(this.base() + ASSET.slash + encodeURIComponent(id) + C.resumePath, null);
  }

  act(unit: ClothingDispositionUnit, request: ClothingDispositionRequest): Observable<ClothingDisposition> {
    let path = this.base() + ASSET.slash + unit.dispositionId + C.actions;
    if (request.action === C.retain) { path = this.base() + C.units + unit.unitId + C.retentionPath; }
    if (request.action === C.returnAction && !unit.dispositionId) {
      path = this.base() + C.units + unit.unitId + C.returnPath;
    }
    return this.http.post<ClothingDisposition>(path, request);
  }

  private base(): string { return this.api.baseApiUrl + C.path; }
}
const EMPLOYEES = '/employees/';
const ITEMS = '/items/';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/clothing-disposition.service.ts